<template>
    <div class="btn_config_config chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.push.type" @change="getRender">内页跳转</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.push.type">
            <span class="span_til">内页配置</span>
            <el-select v-model="config.push.url" placeholder="请选择跳转页"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in groupDpList"
                        :key="item.id"
                        :label="item.screenPageName"
                        :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig textViewConfig" v-if="!config.push.type">
            <span class="span_til">外页跳转</span>
            <el-input
                    class="text_input"
                    type="textarea"
                    autosize
                    size="mini"
                    placeholder="再此修改内容！"
                    v-model="config.push.url"
                    @change="getRender">
            </el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'push_config',
        components: {},
        data() {
            return {
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            groupDpList() {
                if (this.type === 'screen') {
                    let grpList = this.$store.state.designer.groupDpList;
                    grpList.push({
                        "id":null,
                        "screenPageName":'空',
                    })
                    return grpList
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },

        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .btn_config_config {

    }
</style>
